// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HrjPXjJ9f6zoiJ0ZBq8v{color:#dfec24;font-family:rubik,helvetica,arial,sans-serif;font-size:18px;font-weight:900;line-height:18px;padding:0 10px;text-align:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalHeaderTitle": `HrjPXjJ9f6zoiJ0ZBq8v`
};
export default ___CSS_LOADER_EXPORT___;
